module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/flame_bg-32f19fb16bd4d9a2280dead6d9722f92.svg";